import { MagicConfigMixin, ImageFormat, cdnService, FeatureEnabledV2, isDesktopQuery } from '@gig/magic-common';
import { Mixins, Prop, Watch, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Feature, AFFILIATE_QUERY, BREAKPOINT_DEVICE_UPDATED } from '@gig/magic-messages';
import { OFFER_NAMESPACE } from '../../store/modules/offer/offer.store.js';
import { store } from '../../store/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const offers = namespace(OFFER_NAMESPACE);
let OfferCard = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.isCustomOfferEnabled = false;
    this.affiliateTag = "";
    this.showImage = false;
    this.breakpointSubscription = null;
  }
  created() {
    return __async(this, null, function* () {
      var _a;
      this.affiliateTag = (_a = yield window.queryBus.query(AFFILIATE_QUERY)) != null ? _a : "";
      this.breakpointSubscription = window.eventBus.subscribe(BREAKPOINT_DEVICE_UPDATED, (event) => __async(this, null, function* () {
        if (!event.payload) {
          return null;
        }
        this.showImage = yield isDesktopQuery();
      }), { replay: true });
      this.loadOffer();
    });
  }
  destroyed() {
    var _a;
    (_a = this.breakpointSubscription) == null ? void 0 : _a.unsubscribe();
  }
  get offer() {
    const { language } = this.magicConfig;
    return this.getOffersByAffiliate(this.slug, this.affiliateId || "", language)[0];
  }
  get src() {
    return this.getImage(ImageFormat.WEBP);
  }
  get avifSrcset() {
    return this.getImageSrcset(ImageFormat.AVIF);
  }
  get webpSrcset() {
    return this.getImageSrcset(ImageFormat.WEBP);
  }
  get affiliateId() {
    if (!this.affiliateTag || !this.isCustomOfferEnabled) {
      return "";
    }
    return this.affiliateTag.split("_")[0];
  }
  getImageSrcset(format) {
    return `${this.getImage(format)}, ${this.getImage(format, true)} 2x`;
  }
  getImage(format, retina = false) {
    if (!this.offer || !this.offer.image) {
      return "";
    }
    return cdnService.getOfferImageUrl(this.offer.image, {
      width: this.imageWidth,
      quality: 100,
      retina,
      format
    });
  }
  loadOffer() {
    return __async(this, null, function* () {
      try {
        if (!this.affiliateTag) {
          yield this.fetchOffer({
            lang: this.magicConfig.language,
            slug: this.slug
          });
        } else {
          yield this.fetchAllOffers({ lang: this.magicConfig.language });
        }
      } catch (e) {
      }
    });
  }
};
__decorateClass([
  FeatureEnabledV2({
    slug: Feature.CUSTOM_WELCOME_OFFER_BASED_ON_BTAG
  })
], OfferCard.prototype, "isCustomOfferEnabled", 2);
__decorateClass([
  Prop(String)
], OfferCard.prototype, "slug", 2);
__decorateClass([
  Prop({ type: Number, default: 320 })
], OfferCard.prototype, "imageWidth", 2);
__decorateClass([
  offers.Getter("getOffersByAffiliate")
], OfferCard.prototype, "getOffersByAffiliate", 2);
__decorateClass([
  offers.Action("fetchAllOffers")
], OfferCard.prototype, "fetchAllOffers", 2);
__decorateClass([
  offers.Action("fetchOffer")
], OfferCard.prototype, "fetchOffer", 2);
__decorateClass([
  Watch("magicConfig.language", { immediate: true })
], OfferCard.prototype, "loadOffer", 1);
OfferCard = __decorateClass([
  Component({
    name: "offer-card",
    store
  })
], OfferCard);

export default OfferCard;
